import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { Subject, takeUntil } from "rxjs";
import { AlertStackComponent } from "./shared/components/alert-stack/alert-stack.component";
import { MaintenanceComponent } from "./shared/components/maintenance/maintenance.component";
import { MaintenanceService } from "./shared/services/maintenance/maintenance.service";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	imports: [RouterOutlet, AlertStackComponent, MaintenanceComponent]
})
export class AppComponent implements OnInit, OnDestroy {
	private readonly maintenanceService = inject(MaintenanceService);

	private readonly isDestroyed$ = new Subject<void>();

	isUnderMaintenance = false;

	ngOnInit() {
		this.maintenanceService.isUnderMaintenance$
			.pipe(takeUntil(this.isDestroyed$))
			.subscribe({ next: isUnderMaintenance => (this.isUnderMaintenance = isUnderMaintenance) });
	}

	ngOnDestroy() {
		this.isDestroyed$.next();
		this.isDestroyed$.complete();
	}
}
